// SolutionLibrary.js
import React from 'react';
import LibraryImage from '../resorcesfiles/ideak/library1.jpg'; 
import Mainmastet from '../masterpage/Mainmastet';
import './ProductDetails.css';

const SolutionLibrary = () => {
  return (

    <Mainmastet content={<>
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>RFID SYSTEM SOFTWARE</h1>
      <p>
        Radio frequency identification uses electromagnetic fields to automatically identify and track tags
        attached to books. There are several ways of identifying tags, but the most common is to store a serial
        number. The chip and antenna attached together are called an RFID tag. The RFID reader or scanner
        converts the RFID tag information into digital information, which will be further seen on the computer
        and stored for future use.
      </p>
      <p>
        <strong>Library Management system</strong>, RFID, acts as a systematic way of data collection. This system plays an
        important role in redefining the library process by scanning books on the shelves itself without
        tipping them out.
      </p>
      <h2>Benefits of RFID in LMS</h2>
      <ul>
        <li>Scanning made easy with tags</li>
        <li>Faster check-in and check-out facility</li>
        <li>Easy to maintain inventory through wireless system</li>
        <li>Increase accuracy and efficiency</li>
        <li>RFID Gate acts as an anti-theft</li>
        <li>Reduces the time of circulation</li>
      </ul>
      <img src={LibraryImage} alt="RFID System in Library" style={{ width: '500px', margin: '20px 0' }}  className="responsive-image" />
    </div>
    </>} />
  );
};

export default SolutionLibrary;
